module.exports = {
    messages: {
        de: {
            personIndex: {
                clickToSearch: "Klicken Sie auf einen Namen, um nach den Fundstellen zu suchen",
                title: "Personenregister"
            },
            personList: {
                highlighting: "Personenmarkierung",
                noPersonMarked: "Keine Personen auf der aktuellen Seite ausgezeichnet",
                sortingNote: "Personen in Dokumentreihenfolge. Vorkommen im Text rot markiert."
            }
        },
        en: {
            personIndex: {
                clickToSearch: "Click a name in order to search for the name's occurrances",
                title: "Index of names"
            },
            personList: {
                highlighting: "Marked persons",
                noPersonMarked: "No persons marked on current page",
                sortingNote: "Persons listed in document order. Occurrences rubricated in transcripts text."
            }
        },
        fr: {
            personIndex: {
                clickToSearch: "Cliquez sur un nom pour afficher les occurrences",
                title: "Index des noms"//"Registre des personnages"
            },
            personList: {
                highlighting: "Marquage de personnes",
                noPersonMarked: "Aucune personne marquée sur cette page",
                sortingNote: "Listage des personnes en séquence du texte. Occurrences sont marquées de rouge dans les transcriptions."
            }
        }
    }
}
